module.exports = __webpack_public_path__ + "static/media/_2019-03-07_12-d05adbc2-7184-4031-ac61-4fa42796ebc9.01.25.f82b6c58.png";